/* eslint-disable react/prop-types */
import React, { useEffect, useRef, useState } from 'react';
import { Table, Tabs, Tooltip, Typography, Col, Row, Divider, Button, Modal, Form, Input, Upload, notification, DatePicker, Checkbox } from 'antd';
import { FilePdfOutlined, EditOutlined, DeleteOutlined, CloudUploadOutlined, UploadOutlined } from '@ant-design/icons';
import { connect } from 'react-redux';
import { get } from 'lodash';
import {
  fetchAdminEquipDocList,
  deleteDocumentListReport,
  updateDocument,
} from '../../redux/admin/equipmentSno/action';
import MaintenanceChildList from './MaitenanceChildList';
import moment from 'moment';
import CommonAGGridTable from '../AG Grid/CommonAGGridTable';

const { Text } = Typography;
const { TabPane } = Tabs;

const DocumentList = (props) => {
  const {
    equipmentSubTypeId,
    equipmentTypeId,
    setDocumentId,
    documentId,
    equipmentSubTypeName,
    handleSetForm,
    equipmentTypeName,
    onOpenAddDocumentModal,
    //
    onFetchAdminEquipDocList,
    onDeleteDocumentListReport,
    onUpdateDocument,
    adminEquipDocListLoad,
    adminEquipDocListData,
    adminEquipDocTypeData,
    adminEquipDocTypeLoad,
    isDocumentDeleteLoading,
    isDocumentUpdateLoading,
  } = props;

  // const adminEquipDocListData = [
  //     {
  //         "document": {
  //             "id": 8,
  //             "documentName": "Equipment Manual",
  //             "documentTypeId": 1,
  //             "documentTypeCode": "INSTALLATION",
  //             "s3Link": "https://asset-management-dev-server-bucket.s3.us-west-2.amazonaws.com/equipment_docs/176/1/1731909794810-equipment_manual.pdf",
  //             "uploadedAt": "2024-11-18T11:34:56.000Z"
  //         },
  //         "assignedTo": [
  //             "ALL"
  //         ]
  //     },
  //     {
  //         "document": {
  //             "id": 6,
  //             "documentName": "Equipment Manual",
  //             "documentTypeId": 1,
  //             "documentTypeCode": "INSTALLATION",
  //             "s3Link": "https://asset-management-dev-server-bucket.s3.us-west-2.amazonaws.com/equipment_docs/176/1/1731909724609-equipment_manual.pdf",
  //             "uploadedAt": "2024-11-18T11:34:18.000Z"
  //         },
  //         "assignedTo": [
  //             "AC/094",
  //             "AC/093"
  //         ]
  //     }
  // ]

  const expandedData = adminEquipDocListData.flatMap((item, index) =>
    item.assignedTo.map((assignee, i) => ({
      serialNumber: `${index + 1}.${i + 1}`,
      document: item.document,
      documentType: item.document.documentType,
      documentName: item.document.documentName,
      assignedTo: assignee,
    }))
  );

  const [tabChangeId, setTabChangeId] = useState(false);
  const [isDeleteModalVisible, setIsDeleteModalVisible] = useState(false);
  const [isEditModalVisible, setIsEditModalVisible] = useState(false);
  const [selectedData, setSelectedData] = useState('');
  const [editFileList, setEditFileList] = useState([]);
  const [editForm] = Form.useForm();
  const [expirationDate, setExpirationDate] = useState(null);
  const [reminderList, setReminderList] = useState([]);
  const [columnDefs, setColumnDefs] = useState([]);
  const [layoutSave, setLayoutSave] = useState(false);
  const [layoutLoad, setLayoutLoad] = useState(false);
  const [isPivotMode, setIsPivotMode] = useState(false);
  const [gridApi, setGridApi] = useState(null);
  const [loadingProgress, setLoadingProgress] = useState(0);

  const columns = [
    {
      title: 'Serial Number',
      dataIndex: 'assignedTo',
      key: 'assignedTo',
      render: (text) => (
        <Tooltip
          className="tootipChecks"
          title={text}
        >
          <Text>{text}</Text>
        </Tooltip>
      ),
    },
    {
      title: 'Document Name',
      dataIndex: 'documentName',
      key: 'document_name',
      render: (text, record) => (
        <Tooltip
          className="tootipChecks"
          title={text}
        >
          <Text>{record.document.documentName}</Text>
        </Tooltip>
      ),
    },
    // {
    //     title: 'Created Date',
    //     dataIndex: 'uploaded_at',
    //     key: 'uploaded_at',
    //     align: 'center',
    //     render: (text, record) => {
    //         return (
    //             <div>
    //                 {text ? moment.utc(text).format('YYYY-MM-DD') : ''}
    //             </div>
    //         );
    //     },
    // },
    {
      title: 'View',
      dataIndex: 's3Link',
      key: 's3Link',
      width: '10%',
      align: 'center',
      render: (text, record) => {
        return (
          <>
            {record &&
            record.document.s3Link !== null &&
            JSON.stringify(record.document.s3Link) != '{}' ? (
              <Tooltip title="View / Download ">
                <span className="icon-24 mr-2 cursor-pointer edit-hover">
                  <Button
                    href={record?.document?.s3Link}
                    className="p-0 pdfIcon border-0"
                    size="small"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <FilePdfOutlined className="pdfIconRed" />
                  </Button>
                </span>
              </Tooltip>
            ) : (
              <Tooltip title="Report Not Generated">
                <span className="icon-24 mr-2 cursor-pointer edit-hover">
                  <FilePdfOutlined
                    className="gradepdfIconRed"
                    style={{ cursor: 'not-allowed' }}
                  />
                </span>
              </Tooltip>
            )}
          </>
        );
      },
    },
    {
      title: 'Action',
      dataIndex: 'action',
      key: 'action',
      align: 'center',
      width: '10%',
      render: (text, record) => {
        const isAssetCertsAndTests = record?.document?.documentTypeId === 7;
        console.log("record+++++++++",record);
        return (
          <div className="tableIcons">
            {isAssetCertsAndTests && (
              <Tooltip
                title="Edit"
                placement="top"
              >
                {' '}
              <EditOutlined
                className="icon-18"
                style={{ margin: '0 10px', color: '#ef314c', cursor: 'pointer' }}
                onClick={() => {
                  setSelectedData(record);
                  setIsEditModalVisible(true);
                  // Initialize form with existing values
                  editForm.setFieldsValue({
                    documentName: record.document.documentName,
                  });
                  setEditFileList([]);
                  // Initialize expiration date and reminders if available
                  if (record.document.expirationDate) {
                    setExpirationDate(moment(record.document.expirationDate));
                  } else {
                    setExpirationDate(null);
                  }
                  if (record.document.reminderList) {
                    const reminders = typeof record.document.reminderList === 'string' 
                      ? record.document.reminderList.split(',') 
                      : record.document.reminderList;
                    setReminderList(reminders);
                  } else {
                    setReminderList([]);
                  }
                }}
              />
              </Tooltip>
            )}
            <Tooltip
              title="Delete"
              placement="top"
            >
              {' '}
              <DeleteOutlined
                className="icon-18"
                style={{ margin: '0 10px', color: '#ef314c' }}
                onClick={() => {
                  setIsDeleteModalVisible(true);
                  setSelectedData(record);
                }}
              />
            </Tooltip>
          </div>
        );
      },
    },
  ];

  const generateColumns = async () => {
    const columnDefs = [
      {
        headerName: 'S.No',
        field: 'ID',
        maxWidth: 150,
        headerClass: 'ag-center-header',
        cellStyle: { textAlign: 'left' },
        valueGetter: (params) => params.node.rowIndex + 1,
        suppressMovable: true,
        lockPosition: true,
        filter: 'agMultiColumnFilter',
        filterParams: {
          filters: [
            {
              filter: 'agTextColumnFilter',
              filterParams: {
                filterOptions: ['contains', 'equals', 'startsWith', 'endsWith'],
                buttons: ['reset'],
              },
            },
            {
              filter: 'agSetColumnFilter',
              filterParams: {
                buttons: ['reset'],
              },
            },
          ],
        },
      },
      {
        headerName: 'Document Type',
        field: 'documentType',
        headerClass: 'ag-center-header',
        cellStyle: { textAlign: 'left' },
        suppressMovable: true,
        filter: 'agMultiColumnFilter',
        filterParams: {
          filters: [
            {
              filter: 'agTextColumnFilter',
              filterParams: {
                filterOptions: ['contains', 'equals', 'startsWith', 'endsWith'],
                buttons: ['reset'],
              },
            },
            {
              filter: 'agSetColumnFilter',
              filterParams: {
                buttons: ['reset'],
              },
            },
          ],
        },
      },

      {
        headerName: 'Document Name',
        field: 'documentName',
        headerClass: 'ag-center-header',
        cellStyle: { textAlign: 'left' },
        suppressMovable: true,
        filter: 'agMultiColumnFilter',
        filterParams: {
          filters: [
            {
              filter: 'agTextColumnFilter',
              filterParams: {
                filterOptions: ['contains', 'equals', 'startsWith', 'endsWith'],
                buttons: ['reset'],
              },
            },
            {
              filter: 'agSetColumnFilter',
              filterParams: {
                buttons: ['reset'],
              },
            },
          ],
        },
      },

      {
        key: 'assignedTo',
        headerName: 'Assigned To',
        field: 'assignedTo',
        headerClass: 'ag-center-header',
        cellStyle: { textAlign: 'Center' },
        suppressMovable: true,
        filter: 'agMultiColumnFilter',
        filterParams: {
          filters: [
            {
              filter: 'agTextColumnFilter',
              filterParams: {
                filterOptions: ['contains', 'equals', 'startsWith', 'endsWith'],
                buttons: ['reset'],
              },
            },
            {
              filter: 'agSetColumnFilter',
              filterParams: {
                buttons: ['reset'],
              },
            },
          ],
        },
      },

      {
        headerName: 'Actions',
        field: 'actions',
        width: 150,
        headerClass: 'ag-center-header',
        cellStyle: { textAlign: 'center' },
        suppressMovable: true,
        lockPosition: true,
        pinned: 'right',
        filter: false,
        cellRenderer: (params) => {
          const record = params.data;
          if (!record) return <div>-</div>;

          const isAssetCertsAndTests = record?.document?.documentTypeId === 7;

          return (
            <>
              {record &&
              record.document.s3Link !== null &&
              JSON.stringify(record.document.s3Link) != '{}' ? (
                <Tooltip title="View / Download ">
                  <span className="icon-24 mr-2 cursor-pointer edit-hover">
                    <Button
                      href={record?.document?.s3Link}
                      className="p-0 pdfIcon border-0"
                      size="small"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <FilePdfOutlined className="pdfIconRed" />
                    </Button>
                  </span>
                </Tooltip>
              ) : (
                <Tooltip title="Report Not Generated">
                  <span className="icon-24 mr-2 cursor-pointer edit-hover">
                    <FilePdfOutlined
                      className="gradepdfIconRed"
                      style={{ cursor: 'not-allowed' }}
                    />
                  </span>
                </Tooltip>
              )}
              {isAssetCertsAndTests && (
                <Tooltip
                  title="Edit"
                  placement="top"
                >
                  {' '}
              < UploadOutlined  
                className="icon-18"
                style={{ margin: '0 10px', color: '#ef314c', cursor: 'pointer' }}
                onClick={() => {
                  console.log('record', record);
                  setSelectedData(record);
                  setIsEditModalVisible(true);
                  // Initialize form with existing values
                  editForm.setFieldsValue({
                    documentName: record.document.documentName,
                  });
                  setEditFileList([]);
                  // Initialize expiration date and reminders if available
                  if (record.document.expirationDate) {
                    setExpirationDate(moment(record.document.expirationDate));
                  } else {
                    setExpirationDate(null);
                  }
                  if (record.document.reminderList) {
                    const reminders = typeof record.document.reminderList === 'string' 
                      ? record.document.reminderList.split(',') 
                      : record.document.reminderList;
                    setReminderList(reminders);
                  } else {
                    setReminderList([]);
                  }
                }}
              />
                </Tooltip>
              )}
              <Tooltip
                title="Delete"
                placement="top"
              >
                {' '}
                <DeleteOutlined
                  className="icon-18"
                  style={{ margin: '0 10px', color: '#ef314c' }}
                  onClick={() => {
                    setIsDeleteModalVisible(true);
                    setSelectedData(record);
                  }}
                />
              </Tooltip>
            </>
          );
        },
      },
    ];

    setColumnDefs(columnDefs);
    return columnDefs;
  };
  useEffect(() => {
    generateColumns();
  }, []);

  useEffect(() => {
    onFetchAdminEquipDocList({
      equipmentTypeId: equipmentSubTypeId,
      equipmentId: '',
      documentTypeId: documentId,
    });
  }, [tabChangeId]);

  useEffect(() => {
    handleSetForm({ pihEquipment: equipmentSubTypeName, pihCategory: equipmentTypeName });
  }, [equipmentSubTypeName]);

  const handleDeleteOk = async () => {
    // Get documentTypeId from the document object itself, not from the prop
    const documentTypeId = selectedData?.document?.documentTypeId || documentId; // Fallback to prop if not found in document
    
    await onDeleteDocumentListReport({
      equipmentTypeId: equipmentSubTypeId,
      equipmentId: '',
      documentTypeId: documentTypeId,
      s3Link: selectedData.document.s3Link,
      serialNumber: selectedData?.assignedTo,
    });
  };

  useEffect(() => {
    if (!isDocumentDeleteLoading) {
      setIsDeleteModalVisible(false);
      setSelectedData('');
    }
  }, [isDocumentDeleteLoading]);

  const handleDeleteCancel = () => {
    setIsDeleteModalVisible(false);
    setSelectedData('');
  };

  const handleEditCancel = () => {
    setIsEditModalVisible(false);
    setSelectedData('');
    setEditFileList([]);
    setExpirationDate(null);
    setReminderList([]);
    editForm.resetFields();
  };

  const handleEditOk = async () => {
    try {
      const values = await editForm.validateFields();
      
      // Get documentTypeId from the document object itself, not from the prop
      const documentTypeId = selectedData?.document?.documentTypeId || 
                            documentId; // Fallback to prop if not found in document
      
      // Determine newDocumentName:
      // If a new file is uploaded, use the uploaded file's name
      // Otherwise, use the form field value (which could be changed by user or same as existing)
      let newDocumentName;
      if (editFileList.length > 0 && editFileList[0]) {
        // New file uploaded - use the uploaded file's name
        newDocumentName = editFileList[0].name;
      } else {
        // No new file - use the form field value (user may have changed the name)
        newDocumentName = values.documentName || selectedData?.document?.documentName;
      }
      
      console.log("selectedData+++++++++",selectedData);
      const payload = {
        equipmentTypeId: equipmentSubTypeId,
        equipmentId: '',
        documentTypeId: documentTypeId,
        existingDocumentName: selectedData?.document?.documentName,
        newDocumentName: newDocumentName,
        certificate: editFileList.length > 0 ? editFileList : null,
        documentId: selectedData?.document?.id,
        documentS3Link: selectedData?.document?.s3Link,
      };
      
      // Add expiration date and reminder values if documentTypeId is 7 (Asset Certs & Tests)
      if (documentTypeId === 7) {
        if (expirationDate) {
          payload.expirationDate = moment(expirationDate).format('YYYY-MM-DD');
        }
        if (reminderList && reminderList.length > 0) {
          payload.reminderList = reminderList.join(',');
        }
      }
      
      // Add serialNumber from assignedTo (which is a string containing the serialNumber)
      // assignedTo comes from the selected row and is the serialNumber value
      // Send it even if it's "ALL"
      const serialNumber = selectedData?.assignedTo;
      if (serialNumber) {
        payload.serialNumber = serialNumber;
      }
      
      // Explicitly ensure equipmentIds is not included in the payload
      delete payload.equipmentIds;

      console.log("Final payload before sending:", payload);
      
      
      await onUpdateDocument(payload);
    } catch (error) {
      console.error('Validation failed:', error);
    }
  };

  useEffect(() => {
    if (!isDocumentUpdateLoading && isEditModalVisible) {
      setIsEditModalVisible(false);
      setSelectedData('');
      setEditFileList([]);
      setExpirationDate(null);
      setReminderList([]);
      editForm.resetFields();
    }
  }, [isDocumentUpdateLoading]);

  // Sync form field value when file list changes (validation happens on form submit)
  useEffect(() => {
    if (isEditModalVisible) {
      editForm.setFieldsValue({ certificate: editFileList });
    }
  }, [editFileList, isEditModalVisible]);

  const editFileProps = {
    accept: '.pdf,.jpeg,.jpg,.png',
    onRemove: (file) => {
      const index = editFileList.indexOf(file);
      const newFileList = editFileList.slice();
      newFileList.splice(index, 1);
      setEditFileList(newFileList);
    },
    beforeUpload: (file) => {
      const allowedTypes = ['application/pdf', 'image/jpeg', 'image/jpg', 'image/png'];
      const isAllowedType = allowedTypes.includes(file.type);

      if (!isAllowedType) {
        notification.error({
          message: 'Invalid File Type',
          description: 'Only PDF, JPEG, JPG, and PNG files are allowed.',
        });
        return Upload.LIST_IGNORE;
      }
      const updatedFileList = [...editFileList, file];
      setEditFileList(updatedFileList);
      return false;
    },
    fileList: editFileList,
  };

  return (
    <div>
      {onOpenAddDocumentModal && (
        <div className="text-right new-calibration new-project-team mb-2">
          <Text
            onClick={() => onOpenAddDocumentModal(equipmentSubTypeId, equipmentTypeName)}
            className="ps-3 add-new-team"
          >
            <span className="icon-22">
              <svg>
                <use xlinkHref="#add" />
              </svg>
            </span>
            {' '}
            Add New Document
          </Text>
        </div>
      )}
      <div>
        <CommonAGGridTable
          rowData={expandedData}
          columnDefs={columnDefs}
          activeKeyLine="List of Documents"
          isRawListLoading={expandedData.length === 0 || adminEquipDocListLoad}
          loadingMessage="Loading Documents..."
          //onSelectionChanged={handleSelectionChanged}
        />
      </div>

      <Modal
        width="45vw"
        className="pipeline-modal"
        title="Delete Document"
        centered
        visible={isDeleteModalVisible}
        footer={[
          <Button
            key="cancel"
            onClick={handleDeleteCancel}
          >
            Cancel
          </Button>,
          <Button
            key="apply"
            type="primary"
            onClick={handleDeleteOk}
            loading={isDocumentDeleteLoading}
          >
            {isDocumentDeleteLoading ? 'Deleting' : 'Delete'}
          </Button>,
        ]}
      >
        <div>
          <Text style={{ fontSize: '16px' }}>
            Are you sure you want to delete{' '}
            <b style={{ color: '#EF314C' }}>{selectedData && selectedData.document.documentName}</b>{' '}
            document?
          </Text>
        </div>
      </Modal>

      <Modal
        width="45vw"
        className="pipeline-modal"
        title="Upload New Document"
        centered
        visible={isEditModalVisible}
        onCancel={handleEditCancel}
        footer={[
          <Button
            key="cancel"
            onClick={handleEditCancel}
          >
            Cancel
          </Button>,
          <Button
            key="apply"
            type="primary"
            onClick={handleEditOk}
            loading={isDocumentUpdateLoading}
          >
            {isDocumentUpdateLoading ? 'Updating' : 'Update'}
          </Button>,
        ]}
      >
        <Form
          form={editForm}
          layout="vertical"
        >
          <Row gutter={24}>

            <Col lg={24}>
              <Form.Item
                label="Upload New Document"
                name="certificate"
                rules={[
                  {
                    required: true,
                    validator: (_, value) => {
                      const fileList = value || editFileList;
                      if (!fileList || fileList.length === 0) {
                        return Promise.reject(new Error('Please upload a document'));
                      }
                      return Promise.resolve();
                    },
                  },
                ]}
              >
                <Upload {...editFileProps}>
                  <Button
                    icon={<CloudUploadOutlined className="icon-22" />}
                  >
                    Select File
                  </Button>
                </Upload>
                <div style={{ marginTop: '8px', fontSize: '12px', color: '#999' }}>
                  {selectedData?.document?.documentName && (
                    <span>Current file: {selectedData.document.documentName}</span>
                  )}
                </div>
              </Form.Item>
            </Col>
          </Row>
          {selectedData?.document?.documentTypeId === 7 && (
            <Row gutter={24}>
              <Col lg={12}>
                <Form.Item
                  name="Expiration"
                  label="Expiration"
                >
                  <DatePicker
                    value={expirationDate ? moment(expirationDate) : null}
                    onChange={(date) => setExpirationDate(date)}
                    format="DD-MMM-YYYY"
                    placeholder="DD-MM-YYYY"
                    style={{ width: '100%' }}
                  />
                </Form.Item>
              </Col>
              <Col lg={12}>
                <Form.Item>
                  <Checkbox
                    style={{ fontSize: '16px' }}
                    checked={reminderList.length > 0}
                    onChange={(e) => {
                      if (e.target.checked) {
                        setReminderList(['90', '60', '30', '15']);
                      } else {
                        setReminderList([]);
                      }
                    }}
                  >
                    Reminders{' '}
                  </Checkbox>
                  <Checkbox.Group
                    style={{ display: 'block', paddingTop: '5px' }}
                    onChange={(checkedValues) => setReminderList(checkedValues)}
                    value={reminderList}
                  >
                    <Checkbox
                      style={{ marginLeft: '20px' }}
                      value="15"
                    >
                      15 Days
                    </Checkbox>
                    <Checkbox
                      style={{ marginLeft: '20px' }}
                      value="30"
                    >
                      30 Days
                    </Checkbox>
                    <Checkbox
                      style={{ marginLeft: '20px' }}
                      value="60"
                    >
                      60 Days
                    </Checkbox>
                    <Checkbox
                      style={{ marginLeft: '20px' }}
                      value="90"
                    >
                      90 Days
                    </Checkbox>
                  </Checkbox.Group>
                </Form.Item>
              </Col>
            </Row>
          )}
        </Form>
      </Modal>
    </div>
  );
};

const mapStateToProps = ({ adminEquipSnoReducer }) => {
  const adminEquipDocListLoad = get(adminEquipSnoReducer, 'adminEquipDocListLoad', false);
  const adminEquipDocListData = get(adminEquipSnoReducer, 'adminEquipDocListData', []);
  const adminEquipDocTypeLoad = get(adminEquipSnoReducer, 'adminEquipDocTypeLoad', false);
  const adminEquipDocTypeData = get(adminEquipSnoReducer, 'adminEquipDocTypeData', []);
  const isDocumentDeleteLoading = get(adminEquipSnoReducer, 'isDocumentDeleteLoading', false);
  const isDocumentUpdateLoading = get(adminEquipSnoReducer, 'isDocumentUpdateLoading', false);
  return {
    adminEquipDocTypeLoad,
    adminEquipDocTypeData,
    adminEquipDocListLoad,
    adminEquipDocListData,
    isDocumentDeleteLoading,
    isDocumentUpdateLoading,
  };
};

const mapDispatchToProps = {
  onFetchAdminEquipDocList: fetchAdminEquipDocList,
  onDeleteDocumentListReport: deleteDocumentListReport,
  onUpdateDocument: updateDocument,
};

export default connect(mapStateToProps, mapDispatchToProps)(DocumentList);
